import PriceType from "../model/PriceType";
import { addPresentation } from "./presentation";

export default addPresentation(PriceType, {
  canAdd: true,
  canEdit: true,
  canRemove: false,
  columns: ["Code", "Name"],
});
